module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "promotion_price_offer.d90781e2.png";